module.exports = __webpack_public_path__ + "static/scale-model-of-herron-morton-place-park-in-indianapolis-indiana-d8d844b40f289b1199b885d0fa947298.png";